import {
  isIssuedAccessKey,
  isMentorActivationKey,
  isOrgMenteeKey,
  normalizeKey,
} from './keyRegistry';

export const ISSUED_ACCESS_ACTIVATION_ROUTE = '/issued-access';

export function issuedAccessRoute(): string {
  return ISSUED_ACCESS_ACTIVATION_ROUTE;
}

export { isIssuedAccessKey };

export function resolveIssuedPortalDestination(opts: {
  isMentor: boolean;
  agreementAccepted: boolean;
  introCompleted: boolean;
}): string | null {
  if (opts.isMentor) {
    if (!opts.agreementAccepted) return ISSUED_ACCESS_ACTIVATION_ROUTE;
    if (!opts.introCompleted) return '/introduction';
    return '/mentor-console';
  }
  if (!opts.agreementAccepted) return ISSUED_ACCESS_ACTIVATION_ROUTE;
  return null;
}

export function isStoredMentorSession(): boolean {
  if (typeof sessionStorage === 'undefined') return false;
  try {
    return isMentorActivationKey(sessionStorage.getItem('mentology.mentorActivationKey') || '');
  } catch {
    return false;
  }
}

export function storedIssuedKey(): string {
  if (typeof sessionStorage === 'undefined') return '';
  try {
    const mentor = normalizeKey(sessionStorage.getItem('mentology.mentorActivationKey') || '');
    if (isMentorActivationKey(mentor)) return mentor;
    const mentee = normalizeKey(sessionStorage.getItem('mentology.menteeClientKey') || '');
    if (isOrgMenteeKey(mentee) || isIssuedAccessKey(mentee)) return mentee;
    return '';
  } catch {
    return '';
  }
}
